<template>
  <button class="modal-content" :class="{ '-active': active }">
    <div class="modal-content__background" :class="{ '-active': active }"></div>
    <div class="modal-content__content-box" :class="{ '-active': active }">
      <div class="modal-content__description" v-html="parsedDescription"></div>
    </div>
    <div class="modal-content__action" :class="{ '-active': active }">
      <SimpleButton @click="action" :title="actionLabel" />
    </div>
  </button>
</template>

<script>
import showdown from "showdown";
import SimpleButton from "@/components/SimpleButton";

export default {
  name: "ModalContent",
  components: {
    SimpleButton
  },
  props: {
    description: {
      type: String,
      default: undefined
    },
    active: {
      type: Boolean,
      default: false
    },
    actionLabel: {
      type: String,
      default: "Close"
    }
  },
  computed: {
    parsedDescription: function() {
      const converter = new showdown.Converter();
      converter.setOption("tables", true);
      const convertedString = converter.makeHtml(this.description);
      return convertedString;
    }
  },
  methods: {
    action: function() {
      return this.$emit("action");
    }
  }
};
</script>

<style lang="scss">
.modal-content {
  background-color: transparent;
  border: 0;
  color: theme-color("body");
  display: block;
  font-family: $font-family;
  font-size: px-to-rem(16px);
  height: 100vh;
  left: 0;
  opacity: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: z-index("background");
  transition: cta-transition(opacity, 0.6s);

  &__background {
    backdrop-filter: blur(5px);
    background-color: rgba(darken(theme-color("accent-1"), 20%), 0.9);
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    transition: cta-transition(opacity, 0.8s);
    width: 100%;
    z-index: z-index("content");

    &.-active {
      opacity: 1;
    }
  }

  &__content-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: z-index("emphasized");
  }

  &__content-box {
    $_content-box-transition: transform, top;
    background: theme-color("body");
    border-radius: sizes("border-radius");
    display: block;
    left: 50%;
    margin-bottom: spacer("l");
    max-height: 60vh;
    overflow-y: auto;
    padding: spacer("l") spacer("m");
    position: absolute;
    top: 0;
    transform: translate(-50%, -100%);
    transition: cta-transition($_content-box-transition, 0.6s);
    width: 90%;
    z-index: z-index("emphasized");

    @include if-tablet {
      max-height: 500px;
      padding: spacer("l");
      width: 800px;
    }

    &.-active {
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  &__description {
    color: theme-color("black");
    font-size: px-to-rem(18px);
    line-height: 1.5;
    text-align: left;

    & > *:not(:last-child) {
      margin-bottom: spacer("m");
    }

    p {
      text-align: left;
    }

    h1 {
      text-align: center;
      font-size: px-to-rem(24px);

      @include if-tablet {
        font-size: px-to-rem(30px);
      }
    }

    h2,
    h3 {
      display: block;
      line-height: 1.2;
      text-align: left;
    }

    ul,
    ol {
      padding-left: 20px;
    }

    table {
      border-collapse: collapse;
      border: 1px solid theme-color("border");
      font-size: font-size("midi");
    }

    th,
    td {
      border: 1px solid theme-color("border");
      padding: spacer("s");
    }

    th {
      background-color: theme-color("border");
    }
  }

  &__action {
    $_action-transition: bottom, transform, opacity;
    bottom: 0;
    left: 50%;
    opacity: 0;
    position: fixed;
    transform: translate(-50%, 100%);
    transition: cta-transition($_action-transition, 0.6s);
    z-index: z-index("emphasized-more");

    &.-active {
      bottom: spacer("l");
      opacity: 1;
      transform: translate(-50%, 0);
    }
  }

  &.-active {
    opacity: 1;
    z-index: z-index("modal");
  }
}
</style>
